import { render, staticRenderFns } from "./BPFileUpload.vue?vue&type=template&id=2a0a7fcf&"
import script from "./BPFileUpload.vue?vue&type=script&lang=js&"
export * from "./BPFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./BPFileUpload.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BPFileUpload.vue"
export default component.exports